export default __webpack_public_path__ + "static/media/index.e14fe3e6.md";